import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import lang from "../utilities/LanguageConstants";
import { API_KEY } from "../utilities/constants";
import { searchMovieWithFallback } from "../utilities/fetchWithFallback";
import { addGptMovieResult } from "../utilities/gptSlice";
import { useRef } from "react";

const GptSearchBar = () => {
  const langKey = useSelector((store) => store.config.lang);
  const gptSearchTxt = useRef(null);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const callGemini = async (model, prompt) => {
    const url = `https://generativelanguage.googleapis.com/v1beta/models/${model}:generateContent?key=${API_KEY}`;
    const result = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ contents: [{ parts: [{ text: prompt }] }] }),
    });
    const data = await result.json();
    if (data.error) throw new Error(data.error.message);
    return data.candidates?.[0]?.content?.parts?.[0]?.text;
  };

  const handleGptSearchClick = async () => {
    setLoading(true);
    try {
      const searchQuery =
        "Act as movie recommendation system and suggest movies for the query: " +
        gptSearchTxt.current.value +
        ". only give me names of 5 movies, comma separated like the given result ahead. Example Result: Avatar, Sholay, Bahubali, Singham, Krish";

      let text;
      const attempts = [
        { model: "gemini-2.5-flash", delay: 0 },
        { model: "gemini-2.5-flash", delay: 2000 },
        { model: "gemini-2.0-flash", delay: 0 },
      ];
      for (const { model, delay } of attempts) {
        if (delay) await new Promise((r) => setTimeout(r, delay));
        try {
          text = await callGemini(model, searchQuery);
          if (text) break;
        } catch (err) {
          console.warn(`Gemini ${model} failed:`, err.message);
        }
      }
      if (!text) {
        alert(
          "Gemini AI is temporarily overloaded. Please try again in a few minutes.",
        );
        return;
      }

      const gptMovies = text.split(", ").map((movie) => movie.trim());

      const promiseArray = gptMovies.map((movie) =>
        searchMovieWithFallback(movie),
      );
      const tmdbResults = await Promise.all(promiseArray);

      dispatch(
        addGptMovieResult({ movieNames: gptMovies, movieResults: tmdbResults }),
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="pt-[45%] sm:pt-[25%] md:pt-[8%] flex flex-col items-center">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleGptSearchClick();
        }}
        className="w-full md:w-1/2 bg-black grid grid-cols-12 rounded-lg"
      >
        <input
          ref={gptSearchTxt}
          type="text"
          className="p-4 m-4 col-span-9 rounded-lg"
          disabled={loading}
          placeholder={lang[langKey].gptSearchPlaceholder}
        ></input>
        <button
          type="submit"
          disabled={loading}
          className="col-span-3 m-4 py-2 px-2 bg-red-700 rounded-lg text-white disabled:opacity-60 flex items-center justify-center gap-2"
        >
          {loading && (
            <span className="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
          )}
          {loading ? "Searching..." : lang[langKey].search}
        </button>
      </form>
    </div>
  );
};

export default GptSearchBar;
